import { styled } from '@mui/material/styles';
import TableCell from '@mui/material/TableCell';

const DocumentsTableCell = styled(TableCell)({
  fontWeight: 500,
  height: 37,
  paddingTop: 3,
  paddingBottom: 3,
  margin: 0,
});

DocumentsTableCell.defaultProps = {
  align: 'left',
};

export default DocumentsTableCell;
